import { useState } from 'react';
import './post.css';
import mobileImg from '../../assets/mobile.png';

function ArrowLeftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#3d2f7a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 12 20 4l-6.5 16-3-6.5L4 12Z" stroke="#ffffff" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 4v11m0 0-4-4m4 4 4-4" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 19.5h14" stroke="#6c4ce8" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="#ffffff" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4" stroke="#ffffff" strokeWidth="1.8" />
      <circle cx="17" cy="7" r="1.3" fill="#ffffff" />
    </svg>
  );
}

const TOTAL_STEPS = 3;
const ACTIVE_STEP = 3;

export default function Post({
  photo,
  onBack,
  onPost,
  onSaveToGallery,
  instagramUrl = 'https://www.instagram.com/dealzta',
  instagramHandle = '@DealZta',
}) {
  const [confirmed, setConfirmed] = useState(false);
  const [linkClicked, setLinkClicked] = useState(false);

  return (
    <div className="post-screen">
      <div className="post-frame">
        <div className="post-topbar">
          <button type="button" className="post-back-btn" aria-label="Go back" onClick={onBack}>
            <ArrowLeftIcon />
          </button>

          <div className="post-stepper">
            {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map((n) => (
              <span
                key={n}
                className={'post-step-dot' + (n === ACTIVE_STEP ? ' post-step-dot-active' : '')}
              >
                {n}
              </span>
            ))}
          </div>

          <span className="post-topbar-spacer" />
        </div>

        <div className="post-hero">
          <span className="post-badge">{ACTIVE_STEP}</span>
          <div className="post-hero-text">
            <h1 className="post-title">
              Follow The <span className="post-title-accent-pink">Zini</span>.
            </h1>
            <p className="post-subtitle">Share Your Moment With The Shop!</p>
          </div>
        </div>

        <div className="post-image-card">
          <img src={photo || mobileImg} alt="Post your selfie with Zini" className="post-image" />
        </div>

        <div className="post-check-row">
          <label
            className={'post-check' + (!linkClicked ? ' post-check-disabled' : '')}
            aria-label="Click To Post My Photo"
          >
            <input
              type="checkbox"
              className="post-check-input"
              checked={confirmed}
              disabled={!linkClicked}
              onChange={(e) => setConfirmed(e.target.checked)}
            />
          </label>

          <a
            className="post-check-link"
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              setLinkClicked(true);
              setConfirmed(true);
            }}
          >
            <span className="post-insta-icon">
              <InstagramIcon />
            </span>
            I posted my photo and tagged {instagramHandle}
          </a>
        </div>

        <div className="post-actions">
          <button
            type="button"
            className="post-btn-primary"
            onClick={onPost}
            disabled={!confirmed}
          >
            <span className="post-btn-icon">
              <SendIcon />
            </span>
            Upload Photo with Zini
          </button>
        </div>
      </div>
    </div>
  );
}
